export const VENUE_TYPES = [
  { id: "hotel", label: "Hotel" },
  { id: "bnb", label: "Bed & Breakfast" },
  { id: "restaurant", label: "Restaurant / Café" },
  { id: "holiday_let", label: "Holiday Let" },
  { id: "spa", label: "Spa & Wellness" },
  { id: "other", label: "Other venue" },
];

export function venueTerms(vt) {
  const restaurant = vt === "restaurant";
  return {
    menu: restaurant ? "Menu" : "Room Service Menu",
    rooms: vt === "spa" ? "Treatment Rooms" : vt === "holiday_let" ? "Properties" : "Rooms",
    guests: restaurant ? "Customers" : "Guests",
    dine: restaurant ? "Menu" : "Dine",
    stay: restaurant ? "visit" : "stay",
  };
}

export const featureKeys = (f) => (Array.isArray(f) ? f : f ? [f] : []);
